import React, { Component } from "react";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";
import * as actionCreators from "../../../modules/actions/index";
import * as url from "../../../utils/url";
import {
  analyticsCategories,
  initialChartDetailsState,
} from "../../../utils/categories";
import {
  getAgreegateKpisData,
  getBenchmarkData,
  getGenderLists,
  createKPIAgreegateRequestData,
  getFormattedMappingData,
  filterRawBenchmarkData,
} from "../../../utils/filterKpisData";
import {
  editChartStep,
  analyticsSteps,
  getEditChartData,
  kpiBasedType,
  UserRole,
  returnHierarchyGroup,
} from "../../../utils/constants";
import { addChartDetails } from "../../../utils/createRequestData";
import axios from "../../../axios";
import { connect } from "react-redux";
import Steps from "../../../components/Steps/Steps";
import ChartPrivacy from "../Components/ChartPrivacy/ChartPrivacy";
import ChartDetails from "../Components/ChartDetails/ChartDetails";
import Benchmark from "../Components/Benchmark/Benchmark";
import EditOthersChart from "../EditOthersChart/EditOthersChart";
import ErrorMessage from "../../../components/Message/ErrorMessage/ErrorMessage";
import Loading from "../../../hoc/Loading/Loading";
import sortBy from "lodash/sortBy";
import isNull from "lodash/isNull";
import "../Chart.css";

class EditChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kpiList: [],
      isOwner: false,
      industriesList: [],
      emptyStateImage: null,
      orgMapping: {
        gender: {},
        religionOptions: [],
        veteranOptions: [],
        disabilityOptions: [],
        sexualOrientationOptions: [],
        ethnicityOptions: [],
        occupationOptions: [],
        seniorityOptions: [],
        performanceOptions: [],
        separationOptions: [],
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    let category;
    let link = "";
    for (let analyticsCategory of analyticsCategories) {
      if (analyticsCategory.name === this.props.chartDetails.category) {
        category = analyticsCategory.name;
        link = analyticsCategory.link;
      }
    }
    if (nextProps.chartDetails.nextStep === "") {
      this.props.history.push("/home/analytics/" + link);
    }
  }

  componentWillMount() {
    const location = this.props.history.location;
    if (!this.props.chartDetails.category && !this.props.location.state) {
      this.props.history.goBack();
    }
    const category = this.props.match.params.category;
    const unblock = this.props.history.block((location, action) => {
      if (action === "POP")
        return "You have not completed the process yet. Are you sure you want to leave without completing it?";
      if (
        action === "PUSH" &&
        !location.pathname.startsWith(`/home/analytics/${category}/edit`)
      )
        return "You have not completed the process yet. Are you sure you want to leave without completing it?";
    });
    // Listen for changes to the current location.
    const unlisten = this.props.history.listen((location, action) => {
      // location is an object like window.location
      // console.log(action, location.pathname, location.state);
      if (location.pathname !== `/home/analytics/${category}/edit`) {
        this.props.onLeaveEditChart();
        unlisten();
        unblock();
      }
    });
  }

  componentDidMount() {
    let { chartDetails, location } = this.props;
    let category;
    for (let analyticsCategory of analyticsCategories) {
      if (
        analyticsCategory.name === chartDetails.category ||
        analyticsCategory.name === location.state.category
      ) {
        category = analyticsCategory.name;
      }
    }

    if (chartDetails.category && chartDetails.category !== "") {
      this.getKpiListForCategory(category);
      this.getAllIndustries();
    } else {
      if (location.state && location.state.category) {
        let chartDetails = { ...location.state };
        chartDetails.nextStep = editChartStep.details;
        this.props.onEditChartLoaded({
          ...initialChartDetailsState,
          ...chartDetails,
        });
        this.getKpiListForCategory(category);
        this.getAllIndustries();
        // }
      }
    }
  }

  getAllIndustries = () => {
    axios.get(url.getMasterListByCategory("INDUSTRY")).then(({ data }) => {
      // console.log(data.data);
      this.setState({
        industriesList: sortBy(data.data[0].docs, "name"),
      });
    });
  };

  handleChartDetailsCompleted = (details) => {
    let { kpiRecords } = details;
    let { orgMapping } = this.state;
    // next step in Edit Chart --> remove benchmark step
    let nextStep = editChartStep.privacy;
    let selectedKpis = kpiRecords.filter((kpi) => kpi.selected);
    if (
      (selectedKpis && selectedKpis.length > 1) ||
      details.kpiType === kpiBasedType.surveyBased
    ) {
      nextStep = editChartStep.privacy;
    }
    selectedKpis = selectedKpis.map((kpiRecord) => {
      if (details.kpiType === kpiBasedType.empDataBased) {
        let kpiRecordDetails = createKPIAgreegateRequestData(
          kpiRecord,
          orgMapping
        );
        return { ...kpiRecordDetails };
      } else if (details.kpiType === kpiBasedType.surveyBased) {
        return {
          code: kpiRecord.selectedKPI.code,
        };
      }
    });
    this.getKpiAggregate(
      { ...details, selectedKPIRecords: selectedKpis },
      true,
      { nextStep: nextStep, ...details }
    );
  };

  handleBenchmarkCompleted = (benchmark) => {
    this.props.onChartDetailsCompleted({
      nextStep: editChartStep.privacy,
      ...benchmark,
    });
  };

  handleChartPrivacySettingsCompleted = (privacy) => {
    this.props.onChartPrivacySettingsCompleted({
      nextStep: editChartStep.privacy,
      ...privacy,
    });
    this.handleEditChart({ ...this.props.chartDetails, ...privacy });
  };

  handleParentsEditChartComplete = (details) => {
    this.handleEditChart({ ...this.props.chartDetails, ...details });
  };

  // Get kpi list for category
  getKpiListForCategory = (category) => {
    axios
      .get(url.getCategoryKpiList + category)
      .then((response) => {
        if (response && response.data.meta.success) {
          let kpiList = response.data.data;
          kpiList = kpiList.map((kpi) => {
            return {
              id: kpi._id,
              pos: kpi.pos,
              name: kpi.name,
              code: kpi.code,
              description: kpi.description,
              definition: kpi.definition,
            };
          });
          this.setState({ kpiList: kpiList });
          this.getOrganizationMapping();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Get kpi list for category
  getOrganizationMapping = () => {
    let kpiList = this.state.kpiList;
    axios
      .get(url.getExistingMappings(this.props.user.organizationId._id))
      .then((response) => {
        if (response && response.data.meta.success) {
          let {
            gender,
            disability,
            birthDate,
            veteran,
            religion,
            sexualOrientation,
            occupation,
            ethnicity,
            seniority,
            performance,
            separation,
          } = getFormattedMappingData(response.data.data.mapping);
          this.setState({
            kpiList,
            orgMapping: {
              gender,
              sexualOrientationOptions: sexualOrientation,
              disabilityOptions: disability,
              veteranOptions: veteran,
              religionOptions: religion,
              ethnicityOptions: ethnicity,
              occupationOptions: occupation,
              seniorityOptions: seniority,
              performanceOptions: performance,
              separationOptions: separation,
            },
          });
          // console.log(this.state.orgMapping)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Get kpi list for category
  getKpiAggregate = (kpiData, onContinue, details) => {
    let { user, chartDetails } = this.props;
    console.log(user._id, chartDetails);

    let { orgMapping } = this.state;
    console.log(this.state, this.props);
    // console.log(allOfficeKeys)

    let hierarchy = this.props.user.organizationId.staticHierarchy;
    let offKey = this.props.user.officeId.officeKey;
    // this should be in redux/the store, and retrieved with user sign in
    console.log(hierarchy, offKey);
    let allOfficeKeys = returnHierarchyGroup(hierarchy, offKey);

    let { maleList, femaleList, otherList, pntsList, nBnList } = getGenderLists(
      orgMapping
    );

    let payload = {
      kpiList: kpiData.selectedKPIRecords,
      kpiType: kpiData.kpiType,
      startDate: kpiData.startDate,
      endDate: kpiData.endDate,
      allOfficeKeys,
      useLatestDataAvailable: kpiData.useLatestDataAvailable,
      maleList,
      femaleList,
      otherList,
      pntsList,
      nBnList,
      orgMapping,
    };
    let rec = kpiData.selectedKPIRecords;
    this.setState({ error: false, errorMessage: "" });

    if (rec.length > 1) {
      for (var x = 0; x < rec.length; x++) {
        if (JSON.stringify(rec[x]) === JSON.stringify(rec[x + 1])) {
          window.scrollTo(0, 0);
          this.setState({
            error: true,
            errorMessage:
              "Please make sure that the KPIs you select are unique",
          });
          return;
        }
      }
    }

    axios
      .post(url.getkpiAggregate, payload)
      .then((response) => {
        if (response && response.data.meta.success) {
          let kpiAgreegateData = [];
          let kpiBenchmarkData = [];
          if (payload.kpiType === kpiBasedType.empDataBased) {
            kpiAgreegateData = response.data.data.kpi;
            kpiBenchmarkData = response.data.data.benchmark;
          } else if (payload.kpiType === kpiBasedType.surveyBased) {
            kpiAgreegateData = response.data.data;
          }
          let {
            kpiRecords,
            kpiType,
            startDate,
            endDate,
            useLatestDataAvailable,
          } = details;
          let formattedKpiData = getAgreegateKpisData({
            kpiRecords,
            kpiAgreegateData,
            kpiType,
            startDate,
            endDate,
            useLatestDataAvailable,
          });
          kpiBenchmarkData = filterRawBenchmarkData(kpiBenchmarkData);
          let kpiFilterdData = formattedKpiData.filter(
            (kpiData) => kpiData.score
          );
          if (onContinue) {
            if (payload.kpiList.length === 1) {
              if (
                kpiType === kpiBasedType.empDataBased &&
                kpiFilterdData.length !== 0
              ) {
                this.updatekpiAgreegateDataInStore({
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.props.onChartDetailsCompleted({
                  ...details,
                  kpiData: kpiFilterdData,
                });
                this.setState({ error: false });
              } else if (
                kpiType === kpiBasedType.surveyBased &&
                kpiFilterdData.length === 0
              ) {
                window.scrollTo(0, 0);
                this.updatekpiAgreegateDataInStore({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.setState({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  error: true,
                  errorMessage:
                    "To continue, please select KPIs and/or dates for which there is data available.",
                });
                window.scrollTo(0, 0);
                return;
              } else if (
                kpiType === kpiBasedType.empDataBased &&
                kpiFilterdData.length === 0
              ) {
                window.scrollTo(0, 0);
                this.updatekpiAgreegateDataInStore({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.setState({
                  previewOrContinue: true,
                  emptyStateImage: true,
                  error: true,
                  errorMessage:
                    "To continue, please select KPIs and/or dates for which there is data available.",
                });
                window.scrollTo(0, 0);
                return;
              } else if (
                kpiType === kpiBasedType.surveyBased &&
                kpiFilterdData.length > 0
              ) {
                this.updatekpiAgreegateDataInStore({
                  kpiData,
                  kpiAgreegateData: response.data.data,
                  kpiBenchmarkData: kpiBenchmarkData,
                });
                this.props.onChartDetailsCompleted({
                  ...details,
                  kpiData: kpiFilterdData,
                });
                this.setState({ error: false });
              }
            } else if (
              payload.kpiList.length > 1 &&
              kpiFilterdData.length === 0
            ) {
              this.updatekpiAgreegateDataInStore({
                previewOrContinue: true,
                emptyStateImage: true,
                kpiData,
                kpiAgreegateData: response.data.data,
                kpiBenchmarkData: kpiBenchmarkData,
              });
              window.scrollTo(0, 0);
              this.setState({
                previewOrContinue: true,
                emptyStateImage: true,
                error: true,
                errorMessage:
                  "To continue, please select KPIs and/or dates for which there is data available.",
              });
              return;
            } else {
              this.updatekpiAgreegateDataInStore({
                kpiData,
                kpiAgreegateData: response.data.data,
                kpiBenchmarkData: kpiBenchmarkData,
              });
              this.props.onChartDetailsCompleted({
                ...details,
                kpiData: kpiFilterdData,
              });
              this.setState({ error: false });
            }
          } else {
            this.updatekpiAgreegateDataInStore({
              kpiData,
              kpiAgreegateData: response.data.data,
              kpiBenchmarkData,
            });
          }
        }
      })
      .catch((error) => {
        window.scrollTo(0, 0);
        this.setState({
          emptyStateImage: true,
          error: true,
          errorMessage:
            "To continue, please select KPIs and/or dates for which there is data available.",
          previewOrContinue: true,
        });
        this.props.saveAgreegateData({
          previewOrContinue: true,
          emptyStateImage: true,
          kpiAgreegateData: [],
          kpiBenchmarkData: [],
          kpiData: [],
        });
      });
  };

  updatekpiAgreegateDataInStore = ({
    kpiData,
    kpiAgreegateData,
    kpiBenchmarkData,
  }) => {
    let { kpi } = kpiAgreegateData;
    if (kpi !== undefined && kpi !== null) {
      let arrayCheck = true;
      if (kpi.length === 1 && Object.values(kpi[0])[0].length == 0) {
        arrayCheck = false;
      }
      if (arrayCheck !== true) {
        window.scrollTo(0, 0);
        this.props.saveAgreegateData({
          previewOrContinue: true,
          emptyStateImage: true,
          kpiData,
          kpiAgreegateData: kpiAgreegateData.kpi,
          kpiBenchmarkData,
        });
        this.setState({
          previewOrContinue: true,
          emptyStateImage: true,
          error: true,
          errorMessage:
            "To continue, please select KPIs and/or dates for which there is data available.",
        });
        return;
      }
    }
    // console.log(kpiAgreegateData, '----update---', kpiData)
    let dataBool = true;
    if (kpiAgreegateData) {
      if (kpiData.kpiType === "SURVEY_BASED") {
        kpiAgreegateData.map((e) => {
          let v = Object.values(e)[0].length;
          if (v > 0) {
            return (dataBool = false);
          }
        });
        this.setState({
          previewOrContinue: dataBool,
          emptyStateImage: dataBool,
        });
      } else {
        kpi.map((e) => {
          let v = Object.values(e)[0].length;

          if (v > 0) {
            return (dataBool = false);
          }
        });
        this.setState({
          previewOrContinue: dataBool,
          emptyStateImage: dataBool,
        });
      }

      if (kpiData.kpiType === kpiBasedType.empDataBased) {
        this.props.saveAgreegateData({
          kpiData,
          kpiAgreegateData: kpiAgreegateData.kpi,
          kpiBenchmarkData,
        });
      } else if (kpiData.kpiType === kpiBasedType.surveyBased) {
        this.props.saveAgreegateData({
          kpiAgreegateData,
          kpiBenchmarkData: [],
        });
      }
    }
  };

  // Make create chart request if chart data validated.

  handleEditChart = (chartDetails) => {
    let that = this;
    let { user } = this.props;
    let updateChartData = {};
    let navigationFlow = localStorage.getItem("chartNavigationFlow");
    let {
      _id,
      name,
      category,
      kpiType,
      privacy,
      permission,
      genderType,
      kpiAgreegateData,
      kpiRecords,
      selectedBenchmarkData,
      benchmarkLocation,
      startDate,
      endDate,
      useLatestDataAvailable,
    } = chartDetails;
    let isOwnerOrAdmin = !chartDetails._id
      ? true
      : this.isCurrentUserOwnerOrAdmin(user, chartDetails);
    let chartData = {
      kpiAgreegateData,
      kpiRecords,
      genderType,
      selectedBenchmarkData,
      benchmarkLocation,
      startDate,
      endDate,
      kpiType,
    };
    if (isOwnerOrAdmin) {
      updateChartData = { name, useLatestDataAvailable, privacy };
      chartData["permission"] = permission;
    } else {
      updateChartData = { name, useLatestDataAvailable };
    }
    updateChartData = addChartDetails(chartData, updateChartData);

    if (navigationFlow === "edit") {
      axios
        .put(url.editChart(_id), { ...updateChartData })
        .then((response) => {
          localStorage.removeItem("chartNavigationFlow");
          that.props.history.replace(
            `/home/analytics/${this.props.match.params.category}`
          );
        })
        .catch((error) => {
          that.setState({
            error: true,
            errorMessage: "Failed to create a chart. Please try again.",
          });
          window.scrollTo(0, 0);
        });
    } else {
      let updatedObject = {
        ...updateChartData,
        category: chartDetails.category,
        kpiType: chartDetails.kpiType,
      };
      axios
        .post(url.createChart, updatedObject)
        .then((response) => {
          localStorage.removeItem("chartNavigationFlow");
          that.props.history.replace(
            `/home/analytics/${this.props.match.params.category}`
          );
        })
        .catch((error) => {
          that.setState({
            error: true,
            errorMessage: "Failed to create a chart. Please try again.",
          });
          window.scrollTo(0, 0);
        });
    }
  };

  // Handle got to previus page

  handleGoBack = (showEmpty) => {
    let previousStep = "";
    if (this.props.chartDetails.nextStep === editChartStep.benchmark) {
      previousStep = editChartStep.details;
    } else if (this.props.chartDetails.nextStep === editChartStep.privacy) {
      let { kpiRecords } = this.props.chartDetails;
      previousStep = editChartStep.benchmark;
      let selectedKpis = kpiRecords.filter((kpi) => kpi.selected);
      if (
        (selectedKpis && selectedKpis.length > 1) ||
        this.props.chartDetails.kpiType === kpiBasedType.surveyBased
      ) {
        previousStep = editChartStep.details;
      }
    }
    if (showEmpty) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage:
          "To continue, please select KPIs and/or dates for which there is data available.",
        emptyStateImage: true,
        previewOrContinue: true,
      });
    }
    this.props.onGoBackPressed({ nextStep: previousStep });
  };

  handleGetKpiData = (kpiData) => {
    let { orgMapping } = this.state;
    kpiData.selectedKPIRecords = kpiData.selectedKPIRecords.map((kpiRecord) => {
      if (kpiData.kpiType === kpiBasedType.empDataBased) {
        let kpiRecordDetails = createKPIAgreegateRequestData(
          kpiRecord,
          orgMapping
        );
        return { ...kpiRecordDetails };
      } else if (kpiData.kpiType === kpiBasedType.surveyBased) {
        return {
          code: kpiRecord.selectedKPI.code,
        };
      }
    });
    this.getKpiAggregate(kpiData, false, {});
  };

  navigateToCategory = () => {
    let link = "";
    for (let category of analyticsCategories) {
      if (category.name === this.props.chartDetails.category) {
        link = category.link;
      }
    }
    this.props.history.push("/home/analytics/" + link);
  };

  // Is current user is admin or owner of chart
  isCurrentUserOwnerOrAdmin = (user, chartDetails) => {
    if (user && chartDetails._id) {
      return true;
    } else {
      return false;
    }
  };

  isUserOwner = (user, chartDetails) => {
    if (user._id === chartDetails.createdBy._id) {
      // diabled set to false if the user is the owner
      return false;
    } else {
      // disabled on dropdown set to true if not owner
      return true;
    }
  };

  isChartLocked = (chartDetails) => {
    if (chartDetails.lockedDate && chartDetails.lockedDate != null) {
      // diabled set to false if the user is the owner
      return true;
    } else {
      // disabled on dropdown set to true if not owner
      return false;
    }
  };

  render() {
    let {
      kpiList,
      orgMapping,
      error,
      errorMessage,
      industriesList,
    } = this.state;
    let { user, chartDetails } = this.props;
    console.log(chartDetails, user);
    let navigationFlow = !isNull(localStorage.getItem("chartNavigationFlow"))
      ? localStorage.getItem("chartNavigationFlow")
      : "create";
    let isOwnerOrAdmin = this.isCurrentUserOwnerOrAdmin(user, chartDetails);
    let createChartCurrentStep = null;
    let currentChartStep = 0;
    // console.log("this state-----", this.state)
    if (chartDetails.nextStep === editChartStep.details) {
      console.log(this.isChartLocked(chartDetails))
      currentChartStep = 1;
      createChartCurrentStep = (
        <ChartDetails
          onCompleted={this.handleChartDetailsCompleted}
          goBackToPreviousStep={this.handleGoBack}
          kpiList={kpiList}
          orgMapping={orgMapping}
          previewChart={this.handleGetKpiData}
          previewOrContinue={this.state.previewOrContinue}
          industriesList={industriesList}
          user={user}
          isOwner={this.isUserOwner(user, chartDetails)}
          isChartLocked={this.isChartLocked(chartDetails)}
          emptyStateImage={this.state.emptyStateImage}
          {...this.props}
        />
      );
      // } else if (chartDetails.nextStep === editChartStep.benchmark) {
      //   currentChartStep = 2;
      //   createChartCurrentStep = <Benchmark onCompleted={this.handleBenchmarkCompleted}
      //                                       showPreviewTool={this.handleToolShowPreviewTool}
      //                                       goBackToPreviousStep={this.handleGoBack}
      //                                       getKpiData={this.handleGetKpiData}
      //                                       kpiList={kpiList}
      //                                       orgMapping={orgMapping}
      //                                       industriesList={industriesList}
      //                                       user={user}
      //                                       emptyStateImage={this.state.emptyStateImage}
      //                                       isOwner={this.isUserOwner(user, chartDetails)}
      //                                       {...this.props}
      //                                       />;
    } else if (chartDetails.nextStep === editChartStep.privacy) {
      currentChartStep = 2;
      createChartCurrentStep = (
        <ChartPrivacy
          onCompleted={this.handleChartPrivacySettingsCompleted}
          showPreviewTool={this.handleToolShowPreviewTool}
          goBackToPreviousStep={this.handleGoBack}
          industriesList={industriesList}
          user={user}
          isChartLocked={this.isChartLocked(chartDetails)}
          isOwner={this.isUserOwner(user, chartDetails)}
          {...this.props}
        />
      );
    }
    return (
      <div className="mt60">
        <div>
          <Breadcrumb>
            <BreadcrumbItem>
              <a
                className="create-chart-link"
                onClick={this.navigateToCategory}
              >
                {chartDetails.category}
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="create-chart-active-category"></span>
              {navigationFlow === "edit" ? "Edit Chart" : "Create Chart"}
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="create-new-chart-title mt30">
          {navigationFlow === "edit" ? "Edit Chart" : "Create Chart"}
        </div>
        OASKDOKASOKDSOKDA
        {isOwnerOrAdmin ? (
          <div>
            <Row>
              <Col sm="11" md="11">
                <Steps steps={analyticsSteps} currentStep={currentChartStep} />
              </Col>
            </Row>
            {error && <ErrorMessage message={errorMessage} />}
            {createChartCurrentStep}
          </div>
        ) : orgMapping &&
          orgMapping.gender &&
          orgMapping.occupationOptions &&
          orgMapping.seniorityOptions &&
          orgMapping.performanceOptions &&
          orgMapping.separationOptions &&
          (orgMapping.gender.length > 0 ||
            orgMapping.occupationOptions.length > 0 ||
            orgMapping.seniorityOptions.length > 0 ||
            orgMapping.performanceOptions.length > 0 ||
            orgMapping.separationOptions.length > 0) ? (
          <EditOthersChart
            previewChart={this.handleGetKpiData}
            industriesList={industriesList}
            onCompleted={this.handleParentsEditChartComplete}
            orgMapping={orgMapping}
            user={user}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chartDetails: state.analytics.chartDetails,
    // categoryKpiData: state.analytics.categoryKpiData,
    benchmarkOptions: state.analytics.benchmarkOptions,
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onEditChartLoaded: (data) => dispatch(actionCreators.editChartLoaded(data)),
    onCategoryKpiDataRetrived: (data) =>
      dispatch(actionCreators.categoryKpiDataFetched(data)),
    onChartDetailsCompleted: (data) =>
      dispatch(actionCreators.chartDetailsCompleted(data)),
    saveAgreegateData: (data) =>
      dispatch(actionCreators.agreegateDataFetched(data)),
    onChartPrivacySettingsCompleted: (data) =>
      dispatch(actionCreators.chartPrivacySettingsCompleted(data)),
    onGoBackPressed: (data) =>
      dispatch(actionCreators.chartGoBackPressed(data)),
    onEditChartSuccess: (data) =>
      dispatch(actionCreators.editChartSuccess(data)),
    onLeaveEditChart: () => dispatch(actionCreators.leaveEditChart()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(EditChart, axios));
